(function () {

  'use strict';

  // **********************************
  //  Data that this directive needs
  // ----------------------------------
  //
  //

  function pxPrinterGoProfile(
    $timeout, $http, EventServiceEvents, toastr, $filter, OnDeviceConfigService,
    GoProfileModel, $rootScope, $routeParams, URL_PARAMS, PrinterListService
  ) {
    return {
      restrict: 'EA',
      scope: {
        printer: '=printer',
        tenant: '=tenant',
        me: '=me',
        isThisResourceMine: '=isThisResourceMine'
      },
      templateUrl: 'app/components/printerProperties/printerGoProfile/printerGoProfile.template.html',
      link: function (scope) {

        scope.hasPrinterCredential = false;
        scope.hasOnDeviceConfig = false;
        scope.gettingPrinterGoProfile = true;
        scope.gettingGoProfiles = true;
        scope.gettingOnDeviceConfig = true;
        scope.hasGoProfiles = false;
        scope.printerGoProfile = null;
        scope.onDeviceConfig = null;
        scope.thresholdToSwitchCreatedTimeFormat = 6;
        scope.verifyingSignInProfile = false;
        scope.installingGoOnPrinter = false;
        scope.showUninstall = false;
        scope.showInstall = false;
        scope.updateConfigOnPrinter = false;
        scope.ongoingUpdateConfigOnPrinter = false;
        const captionContext = '_GO';

        (function () {
          checkInstallOndeviceSetting();
          setOnDeviceState();
          getPrinterGoProfile();
          getOnDeviceConfig();
          getGoProfileList();
          setListeners();

        })();

        function checkInstallOndeviceSetting() {
          scope.enableOnDevice = scope.tenant.info.enableOnDevice;
          const goDisableContent = $filter('translate')('PrintixGoEnableOnDeviceText').replace(/<\/br\s*[\/]?>/gi, '');
          scope.goDisableContentFormated = $filter('translate')(goDisableContent);
        }

        scope.$watch(function () {
          return scope.printer;
        }, function (val1, val2) {
          if (val1 !== val2) {
            scope.printer = scope.printer;
            scope.installingGoOnPrinter = false;
            scope.ongoingUpdateConfigOnPrinter = false;
            setOnDeviceState();
            checkIfUpdateIsRequired();
          }
        });

        function setOnDeviceState() {
          switch (scope.printer.info.onDeviceInstallState) {
            case 'INSTALLED':
              scope.showUninstall = true;
              scope.showInstall = false;
              scope.statusCaption = 'Installed';
              scope.mode = scope.printer.info.clientLess ? 'Clientless' : 'Clientbased';
              scope.modeTooltip = scope.printer.info.clientLess ? 'ClientlessHint' : 'ClientbasedHint';
              break;
            case 'UNINSTALLED':
              scope.showUninstall = false;
              scope.showInstall = true;
              scope.statusCaption = 'UnInstalled';
              scope.mode = null;
              scope.modeTooltip = null;
              break;
            case 'FAILED':
              scope.showUninstall = true;
              scope.showInstall = true;
              scope.statusCaption = 'FAILED';
              scope.mode = scope.printer.info.clientLess ? 'Clientless' : 'Clientbased';
              scope.modeTooltip = scope.printer.info.clientLess ? 'ClientlessHint' : 'ClientbasedHint';
              break;
            case 'UNKNOWN':
              scope.showUninstall = true;
              scope.showInstall = true;
              scope.statusCaption = 'Unknown';
              scope.mode = null;
              scope.modeTooltip = null;
              break;
            case 'UNINSTALLING':
              scope.showUninstall = false;
              scope.showInstall = false;
              scope.statusCaption = 'Uninstalling';
              scope.mode = null;
              scope.modeTooltip = null;
              break;
            case 'INSTALLING':
              scope.showUninstall = false;
              scope.showInstall = false;
              scope.statusCaption = 'Installing';
              scope.mode = null;
              scope.modeTooltip = null;
              break;
          }

          if (!scope.printer.info.onDeviceInstallState) {
            scope.showInstall = true;
          }
        }

        function getPrinterGoProfile() {
          const url = scope.printer.info._links['px:printerCredential'].href;
          $http.get(url).then(function (response) {
            scope.printerGoProfile = response.data;
            scope.printerGoProfileWithModel = new GoProfileModel(response.data);
            scope.hasPrinterCredential = true;
            scope.gettingPrinterGoProfile = false;
            getSignInProfileSnmpConfig();
          }).catch(function () {
            scope.printerGoProfile = null;
            scope.gettingPrinterGoProfile = false;
            scope.hasPrinterCredential = false;
          });
        }

        function getSignInProfileSnmpConfig() {
          if (scope.printerGoProfile._links['px:snmpConfiguration']) {
            $http.get(scope.printerGoProfile._links['px:snmpConfiguration'].href).then(function (snmpConfig) {
              snmpConfig.data.encodedLink = encodeURIComponent(encodeURIComponent(snmpConfig.data._links.self.href));
              scope.printerGoProfile.snmpConfiguration = snmpConfig.data;
            }).catch(function () {
            });
          } else {
            scope.printerGoProfile.snmpConfiguration = null;
          }
        }

        function getOnDeviceConfig() {
          const url = scope.printer.info._links['px:onDeviceConfig'].href;
          OnDeviceConfigService.getOnDeviceConfigByUrl(url).then(function (onDeviceConfig) {
            scope.onDeviceConfig = onDeviceConfig;
            scope.hasOnDeviceConfig = true;
            scope.gettingOnDeviceConfig = false;
            checkIfUpdateIsRequired();
          }).catch(function () {
            scope.onDeviceConfig = null;
            scope.hasOnDeviceConfig = false;
            scope.gettingOnDeviceConfig = false;
          });
        }

        function checkIfUpdateIsRequired() {
          if (scope.onDeviceConfig) {
            const configUpdateTime = new Date(scope.onDeviceConfig.info.modified).getTime();
            const printerConfigInstallTime = new Date(scope.printer.info.onDeviceInstallTime).getTime();
            if (printerConfigInstallTime < configUpdateTime) {
              scope.updateConfigOnPrinter = true;
            } else {
              scope.updateConfigOnPrinter = false;
            }
          }
        }

        function getGoProfileList() {
          const url = scope.tenant.info._links['px:printerCredentials'].href + '?page=0&pageSize=1&sort=NAME&direction=DESC';
          $http.get(url).then(function (response) {
            if (response.data._embedded) {
              scope.hasGoProfiles = true;
            }
            scope.gettingGoProfiles = false;
          }).catch(function () {
            scope.hasGoProfiles = false;
            scope.gettingGoProfiles = false;
          });
        }

        scope.testPrinterGoProfile = function () {
          toastr.clear();
          scope.verifyingSignInProfile = true;
          let printerId = scope.printer.info._links.self.href.split('/');
          printerId = printerId[printerId.length - 1];
          const url = scope.printer.info._links['px:testPrinterCredential'].href + '?printerIds=' + printerId;
          $http.post(url).then(function (response) {
            toastr.success($filter('translate')('OK'));
            scope.verifyingSignInProfile = false;
          }).catch(function (error) {
            toastr.options = {
              closeButton: true,
              timeOut: 10000
            };
            toastr.error($filter('translate')(error.data.errorCode));
            scope.verifyingSignInProfile = false;
            handleCallbackError(error, url);
          });
        };

        scope.installConfiguration = function () {
          if (!scope.printer.info.onDeviceTaskInstall && !scope.printer.info.onDevicePusherEvent) {
            inlinePrinterInstallation('INSTALLING');
          }
          scope.installingGoOnPrinter = true;
          const url = scope.printer.info._links['px:deviceInstall'].href;
          $http.put(url).then(function (response) {
          }).catch(function (error) {
            toastr.error($filter('translate')('ERROR'));
            handleCallbackError(error, url);
          });
        };

        scope.unInstallConfiguration = function () {
          if (!scope.printer.info.onDeviceTaskInstall && !scope.printer.info.onDevicePusherEvent) {
            inlinePrinterInstallation('UNINSTALLING');
          }
          scope.installingGoOnPrinter = true;
          const url = scope.printer.info._links['px:deviceUninstall'].href;
          $http.put(url).then(function (response) {
          }).catch(function (error) {
            toastr.error($filter('translate')('ERROR'));
            handleCallbackError(error, url);
          });
        };

        scope.updatePrinter = function () {
          if (!scope.printer.info.onDeviceTaskUpdate && !scope.printer.info.onDevicePusherEvent) {
            inlinePrinterInstallation('UPDATING');
          }
          scope.ongoingUpdateConfigOnPrinter = true;
          scope.printer.updateDeviceConfig().then(function () {
          }).catch(function (error) {
            scope.ongoingUpdateConfigOnPrinter = false;
            toastr.error($filter('translate')('Error'));
            handleCallbackError(error, null);
          });
        };

        function inlinePrinterInstallation(action) {
          scope.printer.info.onDeviceInstallState = action;
          setOnDeviceState();
        }

        function handleCallbackError(error, requestBody) {
          if (error.status !== 500) { // THIS CANNOT BE A PERMANENT SOLLUTION
            error.linkCaption = error.data.errorCode + captionContext;
            error.originalRequestBody = requestBody || null;
            $rootScope.$broadcast('REQUEST_ERROR', { error });
          }
        }

        /// /////////////////////////////////
        /// /////////////////////////////////
        /// ///  Open context menu
        /// /////////////////////////////////
        scope.openSignInProfileMenu = function (event, printer, signInProfile) {
          scope.closeAllMenues();
          $timeout(function () {
            scope.menuContent = {
              menuItems: [
                { title: 'CreateSignInProfile', selected: false, type: 'createSignInProfile', breaker: false, disabled: scope.me.isSystemObserver() && !scope.isThisResourceMine },
                { title: 'AssignSignInProfile', selected: false, type: 'selectSignInProfile', breaker: false, disabled: scope.me.isSystemObserver() && !scope.isThisResourceMine },
                { title: 'RemoveSignInProfile', selected: false, type: 'printerRemoveGoConfig', breaker: true, disabled: scope.me.isSystemObserver() && !scope.isThisResourceMine },
                { title: 'Properties', selected: false, type: 'link', href: signInProfile ? '/admin/#/signInProfile/' + signInProfile.id : null, disabled: !signInProfile }
              ],
              context: printer,
              icon: 'icon-printer',
              sizeClass: 'size115',
              type: 'ALLROUND'
            };
            scope.menuContent.context.name = printer.info.name;
            scope.menuSpecs = {
              position: { left: event.clientX, top: event.clientY },
              type: 'ALLROUND'
            };
          }, 50);
        };

        scope.openOnDeviceConfigMenu = function (event, printer, onDeviceConfig) {
          scope.closeAllMenues();
          $timeout(function () {
            scope.menuContent = {
              menuItems: [
                { title: 'CreateGoConfiguration', selected: false, type: 'createOnDeviceConfig', breaker: false, action: 'CREATE', disabled: enableOnDeviceState() || (scope.me.isSystemObserver() && !scope.isThisResourceMine) },
                { title: 'AssignGoConfiguration', selected: false, type: 'assignGoConfiguration', breaker: false, disabled: enableOnDeviceState() || (scope.me.isSystemObserver() && !scope.isThisResourceMine) },
                { title: 'RemoveGoConfiguration', selected: false, type: 'printerRemoveOnDeviceConfig', breaker: true, disabled: enableOnDeviceState() || (scope.me.isSystemObserver() && !scope.isThisResourceMine) },
                { title: 'Properties', selected: false, type: 'link', breaker: false, href: onDeviceConfig ? '/admin/#/goConfiguration/' + onDeviceConfig.id : null, disabled: !onDeviceConfig }
              ],
              context: printer,
              icon: 'icon-printer',
              sizeClass: 'size115',
              type: 'ALLROUND'
            };
            scope.menuContent.context.dontUseTitle = true;
            scope.menuContent.context.name = printer.info.name;
            scope.menuSpecs = {
              position: { left: event.clientX, top: event.clientY },
              type: 'ALLROUND'
            };
          }, 50);
        };

        scope.openContextMenu = function (selectedContextMenuItem, contextPosition, menu) {
          scope.closeAllMenues();
          $timeout(function  () {
            scope.selectedContextMenuItem = selectedContextMenuItem;
            scope.contextPosition = contextPosition;
            scope.context = scope.printer;
            scope.context.name = scope.printer.info.name;
            scope.resource = scope.tenant;
            scope.auxiliaries = {
              tenant: scope.tenant,
              printer: scope.printer,
              goProfile: scope.printerGoProfileWithModel
            };
          }, 50);
        };

        scope.closeAllMenues = function () {
          scope.menuContent = null;
          scope.menuSpecs = null;
          scope.selectedContextMenuItem  =  null;
          scope.contextPosition = null;
          scope.context = null;
        };

        function enableOnDeviceState() {
          if (scope.tenant.info.enableOnDevice === 'SUSPENDED') {
            return true;
          }
          return false;
        }

        scope.showTooltip = function (showTip, position, tooltipScope, context, arg) {
          if (showTip) {
            switch (tooltipScope) {
              case 'site':
                siteTooltip(position, context, arg);
                break;
            }
          } else {
            scope.clearTooltip();
          }
        };

        function siteTooltip(position, title, arg) {
          scope.clearTooltip();
          scope.tooltipContent = {
            title,
            arg,
            type: 'statement'
          };
          scope.tooltipObject = {
            position: { left: position.startX, top: position.startY + 20 }
          };
        }

        scope.clearTooltip = function () {
          scope.tooltipContent = null;
          scope.tooltipObject = null;
        };

        /// /////////////////////////////////
        /// /////////////////////////////////
        /// ///  LISTENERS
        /// /////////////////////////////////
        function setListeners() {
          scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.PRINTER_UPDATE, function (name, data) {
            if (data.printer === scope.printer.info._links.self.href) {
              getPrinterGoProfile();
              getOnDeviceConfig();
            }
          });

          scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.TENANT_ONDEVICE_CONFIG_UPDATED, function (name, data) {
            if (data.onDeviceConfig === scope.onDeviceConfig.info._links.self.href) {
              getOnDeviceConfig();
            }
          });
        }

      }
    };
  }

  pxPrinterGoProfile.$inject = [
    '$timeout', '$http', 'EventServiceEvents', 'toastr', '$filter', 'OnDeviceConfigService',
    'GoProfileModel', '$rootScope', '$routeParams', 'URL_PARAMS', 'PrinterListService'
  ];

  angular
    .module('printix-admin')
    .directive('pxPrinterGoProfile', pxPrinterGoProfile);

})();
